import { render, staticRenderFns } from "./ProjectLaborTypeList.vue?vue&type=template&id=e871d2e2&"
import script from "./ProjectLaborTypeList.vue?vue&type=script&lang=ts&"
export * from "./ProjectLaborTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
